import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CircularProgress from 'material-ui/CircularProgress'

const Overlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 10000;
  font-size: 1.5rem;
  ${({ visible }) => ({
    display: visible ? 'flex' : 'none',
  })}
`

Overlay.propTypes = {
  visible: PropTypes.bool,
}
Overlay.defaultProps = {
  visible: false,
}
Overlay.Loading = ({ visible }) => (
  <Overlay visible={visible}>
    <CircularProgress />
  </Overlay>
)
Overlay.Loading.propTypes = { visible: PropTypes.bool.isRequired }

export default Overlay



// WEBPACK FOOTER //
// ./src/components/modals/Overlay.js